import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";
import { cn } from "@/utils/cn";

interface KPICardProps {
  icon: LucideIcon;
  iconColor: string;
  iconBg: string;
  value: string;
  label: string;
  change?: string;
  changePositive?: boolean;
  delay?: number;
}

export function KPICard({
  icon: Icon,
  iconColor,
  iconBg,
  value,
  label,
  change,
  changePositive = true,
  delay = 0,
}: KPICardProps) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay }}
      whileHover={{ y: -4, boxShadow: "0 12px 24px -8px rgba(0,0,0,0.1)" }}
      className="rounded-[14px] bg-white p-5 shadow-sm border border-[#E2E8F0] transition-all duration-200"
    >
      <div className="flex items-start justify-between">
        <div
          className={cn("flex h-11 w-11 items-center justify-center rounded-xl")}
          style={{ backgroundColor: iconBg }}
        >
          <Icon className="h-5 w-5" style={{ color: iconColor }} />
        </div>
        {change && (
          <span
            className={cn(
              "rounded-full px-2.5 py-1 text-xs font-semibold",
              changePositive
                ? "bg-green-50 text-[#22C55E]"
                : "bg-red-50 text-[#EF4444]"
            )}
          >
            {change}
          </span>
        )}
      </div>

      <div className="mt-4">
        <p className="text-3xl font-bold text-[#0F172A]">{value}</p>
        <p className="mt-1 text-sm text-[#64748B]">{label}</p>
      </div>

      {/* Mini Sparkline */}
      <div className="mt-4 flex items-end gap-1 h-8">
        {[40, 65, 45, 75, 55, 80, 60].map((h, i) => (
          <div
            key={i}
            className="flex-1 rounded-sm bg-[#2563EB]/20"
            style={{ height: `${h}%` }}
          />
        ))}
      </div>
    </motion.div>
  );
}